module.exports = __webpack_public_path__ + "static/media/compass-group-logo.d8168c7e.jpg";